import './popup.less';
import classie from 'classie';

export function addPopup(children, doNotAddNoScroll = false, greenMode = false) {
  const container = document.createElement('div');

  const subContainer = document.createElement('div');
  classie.addClass(container, 'popup-container');

  if (greenMode) {
    classie.addClass(container, 'popup-container--green');
  }

  classie.addClass(subContainer, 'popup-subContainer');
  container.appendChild(subContainer);
  document.body.appendChild(container);

  if (children) {
    subContainer.appendChild(children);
  }

  if (!doNotAddNoScroll) {
    classie.addClass(document.body, 'no-scroll');
  }

  return {container, subContainer};
}

export function removePopup(popup) {
  if (classie.hasClass(document.body, 'no-scroll')) {
    classie.removeClass(document.body, 'no-scroll');
  }
  document.body.removeChild(popup.container);
}



// WEBPACK FOOTER //
// ./spa/lib/popup.jsx